import { render } from "./ClaimsAccount.vue?vue&type=template&id=26e5bc64"
import script from "./ClaimsAccount.vue?vue&type=script&lang=js"
export * from "./ClaimsAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__